const DEFAULT_LOCALE = "ru";
const SUPPORTED_LOCALES = ["en", "ru", "es", "pt"];
function normalizeLocale(lang) {
  if (!lang)
    return null;
  try {
    const code = String(lang).split("-")[0].toLowerCase();
    return SUPPORTED_LOCALES.includes(code) ? code : null;
  } catch (e) {
    return null;
  }
}
function detectBrowserLocale() {
  try {
    const nav = typeof navigator !== "undefined" ? navigator : null;
    const lang = nav && (nav.language || nav.languages && nav.languages[0]) || null;
    return normalizeLocale(lang) || null;
  } catch (e) {
    return null;
  }
}
function detectPreferredLocale() {
  try {
    const stored = localStorage.getItem("locale");
    const normalized = normalizeLocale(stored);
    if (normalized)
      return normalized;
  } catch (e) {
  }
  return DEFAULT_LOCALE;
}
function getActiveLocale() {
  try {
    const stored = localStorage.getItem("locale");
    if (stored)
      return normalizeLocale(stored) || stored;
  } catch (e) {
  }
  return DEFAULT_LOCALE;
}
const _getLocale = getActiveLocale;
export {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  _getLocale,
  detectBrowserLocale,
  detectPreferredLocale,
  getActiveLocale,
  normalizeLocale
};
